import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionReplace from 'react-css-transition-replace';

import Fate from 'components/Fate';
import GeneralContainer from 'components/GeneralContainer';
import Loading from 'components/Loading';

class FateContainer extends Component {
  /**
   * render
   * @return {undefined}
   */
  render() {
    const { data, hasFetched } = this.props;

    return (
      <GeneralContainer loading={!data}>
        <ReactCSSTransitionReplace transitionName="fade-wait" transitionEnterTimeout={100} transitionLeaveTimeout={100}>
          {!hasFetched ? <Loading key="loading" /> : <Fate key="fate" data={data} />}
        </ReactCSSTransitionReplace>
      </GeneralContainer>
    );
  }
}

FateContainer.displayName = 'FateContainer';


const mapStateToProps = state => (
  {
    hasFetched: state.fate.hasFetched,
    data: state.fate.data,
  }
);

export default connect(mapStateToProps)(FateContainer);
